// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3Au95","col":"CardReaderDesc_col__3oCoc","label":"CardReaderDesc_label__yR2hA"};